import { Edge, Node, OnConnectStartParams } from "@xyflow/react";
import Interaction, { InteractionType } from "../../models/interactions/Interaction";
import { SequenceNodeData } from "./SequenceNode";

export const TEMP_TARGET_NODE_ID = "temp-target";

export function createTemporaryTargetNode(
  position: { x: number; y: number }
): Node<SequenceNodeData> {
  return {
    id: TEMP_TARGET_NODE_ID,
    type: "sequence",
    position,
    data: {
      name: "",
      id: TEMP_TARGET_NODE_ID,
      interaction: {
        id: "temp",
        name: "",
        type: InteractionType.InspectProp,
      } as Interaction,
    },
    style: { opacity: 0, pointerEvents: "none" },
    draggable: false,
    selectable: false,
  };
}

export function createTemporaryConnectionEdge(
  pendingConnectionSource: OnConnectStartParams,
  temporaryEdgeId: string
): Edge | null {
  if (!pendingConnectionSource.nodeId) {
    return null;
  }

  if (pendingConnectionSource.handleType === "source") {
    return {
      id: temporaryEdgeId,
      source: pendingConnectionSource.nodeId,
      sourceHandle: pendingConnectionSource.handleId || null,
      target: TEMP_TARGET_NODE_ID,
      type: "custom",
      data: {
        isTemporary: true,
      },
    };
  }

  return {
    id: temporaryEdgeId,
    source: TEMP_TARGET_NODE_ID,
    sourceHandle: null,
    target: pendingConnectionSource.nodeId,
    targetHandle: pendingConnectionSource.handleId || null,
    type: "custom",
    data: {
      isTemporary: true,
    },
  };
}
